<template>
  <div v-if="!responseStatus">
    <table style="width: 100%;">
      <tbody>
        <tr>
          <td>
            <i class="fas fa-user"></i>
            <span :style="nameStyle">{{ currentUser.name }}</span>
            <span v-if="!is_all_public">名前がありません</span>
          </td>
          <td class="enable-column">
            <is-enable v-model="is_all_public" title="投稿を公開状態にする" :disabled="this.currentUser.default_mag_setting.is_private_account" />
          </td>
        </tr>
        <tr>
          <td><textarea v-model="memo" placeholder="メモを記入" class="form-control"/></td>
          <td class="enable-column">
            <is-enable v-model="is_public_memo" title="メモを公開する" :disabled="!is_all_public" />
          </td>
        </tr>
        <tr>
          <td><score v-model="score" /></td>
          <td class="enable-column">
            <is-enable v-model="is_public_score" title="スコアを公開する" />
          </td>
        </tr>
        <tr>
          <td>
            <created-minutes-ago v-model="created_minutes_ago" />
          </td>
          <td class="enable-column"></td>
        </tr>
        <tr>
          <td :style="tweetStyle">
            <i class="fab fa-twitter"></i>
            {{ this.currentUser.default_mag_setting.tweet }}
          </td>
          <td class="enable-column">
            <is-enable v-model="is_share_twitter" title="Twitterに投稿する" :disabled="!currentUser.default_mag_setting.enable_twitter || !is_all_public">
              <i class="fab fa-twitter"></i>
            </is-enable>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <button type="button" class="btn btn-primary btn-block" @click="submit">
              まぐわった！
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else-if="responseStatus === 'ok'">
    <h1>🎉おめでとうございます🎉</h1>
    <span v-if="magCount % 5 === 0 || magCount === 1">
      記念すべき第{{ magCount }}回目のまぐわいです！
    </span>
    <span v-else>
      第{{ magCount }}回目のまぐわいです！
    </span>
    セックスを行うことで仲をどんどん深めていきましょう。
  </div>
  <div v-else>
    <h1 style="color: red;"><i class="fas fa-exclamation-circle"></i>エラーが発生しました</h1>
    <ul>
      <li v-for="error in errors">
        {{error}}
      </li>
    </ul>
  </div>
</template>

<script>
import apiAgent from '../common/api_agent'
import IsEnable from './_is_enable'
import CreatedMinutesAgo from './_created_minutes_ago'
import Score from './_score'

export default {
  components: { Score, IsEnable, CreatedMinutesAgo },
  props: ['currentUser'],
  data() {
    return {
      memo: '',
      is_share_twitter: true,
      is_public_memo: true,
      is_public_score: true,
      is_all_public: true,
      created_minutes_ago: 0,
      score: 0,
      magCount: 0,
      responseStatus: null,
      errors: []
    }
  },
  mounted() {
    const settingKeys = ['is_share_twitter', 'is_public_memo', 'is_public_score']
    for (const key of settingKeys) {
      this.$set(this, key, this.currentUser.default_mag_setting[key])
    }
    if (this.currentUser.default_mag_setting.is_private_account) {
      this.is_all_public = false
      this.is_public_memo = false
      this.is_share_twitter = false
    }
  },
  methods: {
    async submit() {
      const data = {
        mag: {
          memo: this.memo,
          score: this.score,
          is_share_twitter: this.is_share_twitter,
          is_public_memo: this.is_public_memo,
          is_public_score: this.is_public_score,
          created_minutes_ago: this.created_minutes_ago,
          is_private: !this.is_all_public
        }
      }
      const response = await apiAgent({
        url: '/api/mags/',
        method: 'POST',
        data: data
      })
      const json = await response.json()
      this.memo = ''
      this.responseStatus = json.status
      this.magCount = json.mag_count
      if (json.status === 'ok') {
        this.$emit('add-mag', json.created_mag)
      } else {
        console.log(json.errors)
        this.errors = Object.values(json.errors).flat()
      }
    }
  },
  computed: {
    tweetStyle() {
      return {
        'text-decoration': this.is_share_twitter ? 'none' : 'line-through',
        color: this.is_share_twitter ? '#495057' : 'LightGray'
      }
    },
    nameStyle() {
      return {
        'text-decoration': this.is_all_public ? 'none' : 'line-through',
        color: this.is_all_public ? '#495057' : 'LightGray'
      }
    }
  },
  watch: {
    is_all_public(newValue, oldValue) {
      if (!newValue) {
        this.is_public_memo = false
        this.is_share_twitter = false
      }
    }
  }
}
</script>

<style scoped>
table {
  color: #495057;
  font-size: large;
}
.enable-column {
  width: 39px;
}
</style>
